import { render, staticRenderFns } from "./FlightV2.vue?vue&type=template&id=05b53f2e"
import script from "./FlightV2.vue?vue&type=script&lang=js"
export * from "./FlightV2.vue?vue&type=script&lang=js"
import style0 from "./FlightV2.vue?vue&type=style&index=0&id=05b53f2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports